import React from 'react';
import PropTypes from 'prop-types';
import InputNumber from '../../Input/InputNumber';
import styles from './styles.less';

const symbolCurrency = {
  AMD: '֏',
  USD: '$',
  EUR: '€',
  RUB: '₽',
};

const Price = ({ t, updateContent, freeCourse, price, defaultCurrency }) => (
  <>
    <div className={styles.priceContainer}>
      <InputNumber
        version="default"
        type="number"
        size="large"
        disabled={freeCourse}
        min={0}
        placeholder={t('details.edit.courses.form.priceamount')}
        onChange={e => updateContent('price', e)}
        value={freeCourse ? null : price}
        addonAfter={symbolCurrency[defaultCurrency]}
        className={styles.priceInput}
      />
      {
        // To do
        /* <div>{symbolCurrency[defaultCurrency]}</div> */
      }
    </div>
  </>
);

Price.propTypes = {
  updateContent: PropTypes.func,
  t: PropTypes.func,
  freeCourse: PropTypes.bool,
  price: PropTypes.string,
  defaultCurrency: PropTypes.string,
};

Price.defaultProps = {
  updateContent: () => {},
  t: () => {},
  freeCourse: false,
  price: '',
  defaultCurrency: '',
};

export default Price;
